import { Spinner } from '@/components/ui/spinner';

/**
 * Full-page loading spinner for lazy-loaded routes.
 * Used as Suspense fallback for code-split route components.
 */
export function PageLoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <Spinner />
    </div>
  );
}
